module.exports = __webpack_public_path__ + "img/birthday-cake-2.1ba7430b.svg";